import { Button } from '@/atoms/Button'
import { Image } from '@/atoms/Image'
import { ParagraphLG, ParagraphMD } from '@/atoms/Text'
import { GTitleLG, GTitleXXL } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { useYoungWashingtonTickets } from '../hooks/useYoungWashingtonTickets'

export default function MakeHistory() {
  const { handleBuyTicketsClick, ctaText } = useYoungWashingtonTickets()

  return (
    <section id="make-history-section" className=" bg-[#00142C] py-10 md:p-16">
      <div className="mx-auto px-4 md:max-w-[1200px]">
        <div className="flex flex-col overflow-hidden rounded-3xl lg:flex-row">
          <div className="aspect-h-3 aspect-w-4 relative w-full md:aspect-h-9 md:aspect-w-16 lg:order-2 lg:w-1/2">
            <Image
              src="v1760204889/young-washington/Still_2025-10-10_142314_1.4.2"
              alt="Young Washington scene"
              className="h-full w-full object-cover object-[37%_50%]"
              fill
            />
          </div>
          <div className="relative flex-1 p-6 pt-8 lg:order-1 lg:p-20">
            <div aria-hidden="true" className="pointer-events-none absolute inset-0">
              <div className="absolute inset-0 bg-[#2A4C76]"></div>
              <div
                className="bg-top-left absolute inset-0 bg-repeat opacity-30 mix-blend-multiply"
                style={{
                  backgroundImage:
                    "url('https://images.angelstudios.com/image/upload/c_limit,w_1200,q_50/v1759419818/theatrical/young%20washington/dirt-texture-on-white-01.webp')",
                  backgroundSize: '1024px 512px',
                }}
              ></div>
            </div>
            <div className="relative flex h-full flex-col justify-center text-white">
              <GTitleXXL className="hidden md:block">Make History With Us</GTitleXXL>
              <GTitleLG className="md:hidden">Make History With Us</GTitleLG>
              <ParagraphLG className={'mb-12 mt-2 hidden !font-roboto !font-light md:block'}>
                Our goal is to make Young Washington the #1 movie in theaters on America&apos;s 250th birthday. By
                buying your tickets early, you help Young Washington secure more theaters, reach more people, and prove
                there&apos;s a hunger for stories that celebrate America. Reserve your tickets today, and join the
                revolution.
              </ParagraphLG>
              <ParagraphMD className={'mb-8 mt-3 !font-roboto !font-light md:hidden'}>
                Our goal is to make Young Washington the #1 movie in theaters on America&apos;s 250th birthday. By
                buying your tickets early, you help Young Washington secure more theaters, reach more people, and prove
                there&apos;s a hunger for stories that celebrate America. Reserve your tickets today, and join the
                revolution.
              </ParagraphMD>
              <Button
                variant={'white'}
                outline={true}
                size={'md'}
                className={'border-2 !font-roboto md:w-fit'}
                onClick={() => handleBuyTicketsClick('make-history')}
              >
                {ctaText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
